document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".slider-wrapper").forEach(sliderWrapper => {
    const isMobile = window.matchMedia("(max-width: 767px)").matches;
    const isDesktopEnabled = sliderWrapper.classList.contains("desktop-enabled");

    // Skip if not mobile and not marked for desktop use
    if (!isMobile && !isDesktopEnabled) return;

    const sliderTrack = sliderWrapper.querySelector(".slider-track");
    const dots = sliderWrapper.querySelectorAll(".slider-dot");

    if (!sliderTrack || dots.length === 0) return;

    let currentSlide = 0;
    const totalSlides = dots.length;

    function goToSlide(index) {
      currentSlide = index;
      const offset = -index * 100;
      sliderTrack.style.transform = `translateX(${offset}%)`;
      dots.forEach(dot => dot.classList.remove("active"));
      dots[index].classList.add("active");
    }

    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => goToSlide(index));
    });

    // Swipe (mobile only)
    let startX = 0;
    sliderTrack.addEventListener("touchstart", e => {
      startX = e.touches[0].clientX;
    });

    sliderTrack.addEventListener("touchend", e => {
      let endX = e.changedTouches[0].clientX;
      let diff = startX - endX;
      if (Math.abs(diff) > 50) {
        if (diff > 0 && currentSlide < totalSlides - 1) {
          goToSlide(currentSlide + 1);
        } else if (diff < 0 && currentSlide > 0) {
          goToSlide(currentSlide - 1);
        }
      }
    });

    goToSlide(0); // Initialize
  });
});
